export const clientAccessActionTypes = {
  GET_TEAM_CLIENTS: 'client-access/GET_TEAM_CLIENTS',
  GET_TEAM_CLIENTS_PENDING: 'client-access/GET_TEAM_CLIENTS_PENDING',
  GET_TEAM_CLIENTS_SUCCESS: 'client-access/GET_TEAM_CLIENTS_SUCCESS',
  GET_TEAM_CLIENTS_FAILED: 'client-access/GET_TEAM_CLIENTS_FAILED',

  REVOKE_CLIENT_ACCESS: 'client-access/REVOKE_CLIENT_ACCESS',
  REVOKE_CLIENT_ACCESS_PENDING: 'client-access/REVOKE_CLIENT_ACCESS_PENDING',
  REVOKE_CLIENT_ACCESS_SUCCESS: 'client-access/REVOKE_CLIENT_ACCESS_SUCCESS',
  REVOKE_CLIENT_ACCESS_FAILED: 'client-access/REVOKE_CLIENT_ACCESS_FAILED',
};
